import { styled } from '@mui/material/styles';
import { Grid, Box, Typography } from '@mui/material';

export const CardContainer = styled(Box)`
    background-color: #373435;
`;

export const TitleContainer = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    margin-bottom: 8px;
`;

export const TotalValueContainer = styled(Grid)`
    justify-content: space-between;
    align-items: center;
    padding: 0 16px 16px 16px;
`;

export const TitleTypography = styled(Typography)`
    font-weight: 600;
    font-family: inherit;
    font-size: 16px;
    color: ${({ negativeValue }) => (negativeValue ? '#E26257' : 'white')};
`;
